import RoleBadgeTag from "@/components_v2/Tags/RoleBadgeTag";
import { getUserRoleBadgeName } from "@/domains/users/getUserRoleBadgeName";

import type { AccountHeaderProps } from "../../types";

const AccountHeader = ({ currentUser }: AccountHeaderProps) => {
  const currentUserRole = getUserRoleBadgeName(currentUser);

  return (
    <div className="account-popover-content flex flex-col gap-100">
      <div className="flex items-center gap-100 flex-wrap">
        <p className="account-popover-name body-m-medium one-line-ellipsis">
          <strong>{currentUser.fullName}</strong>
        </p>

        {currentUserRole && <RoleBadgeTag role={currentUserRole} />}
      </div>

      <p className="account-popover-muted body-s-regular">
        {currentUser.email}
      </p>

      {currentUser.organization ? (
        <p className="account-popover-muted">{currentUser.organization.name}</p>
      ) : null}
    </div>
  );
};

export default AccountHeader;
